<div class="message-block">
  <div class="agent-message-container">
    <div class="agent-message" [innerHTML]="msg.body | convertLinkable | safeHtml"></div>
    <div>
      <strong>{{msg.displayName}}</strong>
      <div>{{msg.timestamp | date : 'EE, MMM d, h:mm a'}}</div>
    </div>
  </div>
</div>
